export const AsyncExecutionManager = function() {
	let i = 0;
	let getToken = function() { return ++i; };
	let mustExec = function(j) { return i === j; };
	let getExecutor = function(f) {
		let j = getToken();
		let attemptExecution = function(params) { if(mustExec(j)){ f(params); } };
 		return { 'attemptExecution': attemptExecution };
	};
	let inhibitExecution = function(){ getToken(); };
	return { 'getExecutor': getExecutor, 'inhibitExecution': inhibitExecution };
};
